import { Directive, TemplateRef } from '@angular/core';
/**
 * Used for rendering the cell content of the Calendar.
 *
 * To define the cell template, nest a `<ng-template>` tag with the `kendoCalendarCellTemplate` directive inside the component tag.
 *
 * The template context is set to the current component. To get a reference to the current date, use the `let-date` directive.
 * To provide more details about the current cell, get a reference to the current `cellContext` by using the `let-cellContext` directive.
 *
 * @example
 * ```ts
 * @@Component({
 * selector: 'my-app',
 * styles: ['.custom { color: red; }'],
 * template: `
 *  <kendo-calendar>
 *    <ng-template kendoCalendarCellTemplate let-date>
 *      <span class="custom">{{date.getDate()}}</span>
 *    </ng-template>
 *  </kendo-calendar>
 * `
 * })
 * class AppComponent { }
 * ```
 *
 * For more examples, refer to the section on [templates]({% slug overview_calendar_kendouiforangular %}#toc-templates).
 */
var CellTemplateDirective = (function () {
    function CellTemplateDirective(templateRef) {
        this.templateRef = templateRef;
    }
    return CellTemplateDirective;
}());
export { CellTemplateDirective };
CellTemplateDirective.decorators = [
    { type: Directive, args: [{
                selector: '[kendoCalendarCellTemplate]'
            },] },
];
/** @nocollapse */
CellTemplateDirective.ctorParameters = function () { return [
    { type: TemplateRef, },
]; };



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@progress/kendo-angular-dateinputs/dist/es/calendar/templates/cell-template.directive.js
// module id = ../../../../@progress/kendo-angular-dateinputs/dist/es/calendar/templates/cell-template.directive.js
// module chunks = 3